<template>
  <div>
    <h3 class="title is-3">Packs</h3>
    <button class="button is-primary" @click="packCreate">Create a new pack</button>

    <p>&nbsp;</p>

    <b-field grouped>
      <b-input
          expanded
          icon="magnify"
          v-model="searchFilter"
          placeholder="Search for packs..."
          @input="searchFilterChanged">
      </b-input>
      <b-checkbox v-model="emptyPackFilter" @input="searchFilterChanged">Hide empty packs</b-checkbox>
    </b-field>


    <b-table
        :data="packsFiltered"
        :default-sort="['createdDate', 'desc']"
        :hoverable="true"
        :loading="isLoading"
        :paginated="true"
        :pagination-simple="true"
        :per-page="50"
        :striped="true">
      <template slot-scope="props">
        <b-table-column class="centered-table-content" field="name" label="Pack name" sortable>
          {{ props.row.name }}
        </b-table-column>

        <b-table-column class="centered-table-content" field="description" label="Description" sortable>
          <i>{{ props.row.description }}</i>
        </b-table-column>

        <b-table-column class="centered-table-content" field="suitableFor" label="Suitable for" width="100">
          <b-taglist>
            <b-tag
                v-for="(age, index) in props.row.suitableFor"
                :key="index"
                type="is-warning">{{ age }}
            </b-tag>
          </b-taglist>
        </b-table-column>

        <b-table-column class="centered-table-content" field="tags" label="Tags" width="150">
          <b-taglist>
            <b-tag
                v-for="(tag, index) in props.row.tags"
                :key="index"
                type="is-info">{{ tag }}
            </b-tag>
          </b-taglist>
        </b-table-column>

        <b-table-column class="centered-table-content" field="rawActivityIds" label="Activities" numeric>
          {{ props.row.rawActivityIds ? props.row.rawActivityIds.length : 0 }}
        </b-table-column>

        <b-table-column class="centered-table-content" field="createdDate" label="Created">
          {{ props.row.createdDate }}
        </b-table-column>

        <b-table-column class="centered-table-content" label="Actions">
          <b-button icon-right="pen" size="large" type="is-text"
                    @click="packEdit(props.row.packId)"></b-button>
          <b-button icon-right="link" size="large"
                    type="is-text" @click.prevent="associateActivities(props.row)"></b-button>
          <b-button icon-right="delete" size="large"
                    type="is-text" @click="openPackDeleteDialog(props.row.packId)"></b-button>
        </b-table-column>
      </template>
    </b-table>

  </div>
</template>

<script>
import packService from '../services/packService'
import displayHelper from '../helpers/display-helper'
import ActivityPackAssociation from './single/ActivityPackAssociation'
import {DialogProgrammatic as Dialog} from 'buefy'

export default {
  name: 'Packs',
  components: {
    ActivityPackAssociation,
  },
  data() {
    return {
      isLoading: false,
      packs: [],
      packsFiltered: [],
      emptyPackFilter: true,
      searchFilter: null,
      columns: [
        {field: 'name'},
        {field: 'description'},
        {field: 'tags'},
      ],
    }
  },
  created() {
    this.isLoading = true
    this.loadPacksList()
  },
  methods: {
    loadPacksList() {
      var parent = this
      packService.getPacks()
          .then(packs => {
            this.packs = packs
            this.packsFiltered = packs
          })
          .catch((err) => {
            displayHelper.displayError(parent, 'Oops.. An error occurred: ' + err.message)
          })
          .finally(() => {
            this.isLoading = false
            this.searchFilterChanged()
          })
    },
    packCreate(packId) {
      this.$router.push({name: 'CreatePack'})
    },
    openPackDeleteDialog(packId) {
      Dialog.confirm({
        message: 'Are you sure you want to delete this pack?',
        onConfirm: () => this.deletePack(packId)
      })
    },
    packEdit(packId) {
      this.$router.push({name: 'EditPack', params: {id: packId}})
    },
    associateActivities(pack) {
      this.$router.push({name: 'ActivityPackAssociation', params: {id: pack.packId, name: pack.name}})
    },
    deletePack(packId) {
      var parent = this
      this.isLoading = true
      packService.deletePack(packId)
          .then(() => {
            displayHelper.displaySuccess(parent, 'Pack successfully deleted')
          })
          .catch((err) => {
            displayHelper.displayError(parent, 'Error while deleting the pack: ' + err.message)
          })
          .finally(() => {
            this.loadPacksList()
          })
    },
    searchFilterChanged(e) {
      if (this.searchFilter && this.searchFilter !== '') {
        let searchLower = this.searchFilter.toLowerCase()
        this.packsFiltered = this.packs.filter((row, index, arr) => {
          let found = false
          for (let col of this.columns) {
            if (row[col.field] && row[col.field].toString().toLowerCase().indexOf(searchLower) >= 0 &&
                this.includeOrNotEmptyPacks(row)) {
              found = true
            }
          }
          return found
        })
      } else {
        this.packsFiltered = _.filter(this.packs, row => {
          return this.includeOrNotEmptyPacks(row)
        })
      }
    },
    includeOrNotEmptyPacks(pack) {
      if (this.emptyPackFilter) {
        return pack.rawActivityIds && pack.rawActivityIds.length > 0
      }
      return true
    },
  }
}
</script>

<style scoped>
</style>
